import React, {Component} from 'react';

class Default extends Component {
    render() {
        return (
            <div>
                <h3>Why are you here?</h3>
            </div>
        );
    }
}

export default Default;
